// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FlocSearch_title__Q8CqG {
  margin: 0 3px 37px 0;
  font-family: Roboto;
  font-size: 38px;
  font-weight: 300;
  line-height: 1.45;
  letter-spacing: 0.5px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/FlocSearch/FlocSearch.module.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AACF","sourcesContent":[".title {\r\n  margin: 0 3px 37px 0;\r\n  font-family: Roboto;\r\n  font-size: 38px;\r\n  font-weight: 300;\r\n  line-height: 1.45;\r\n  letter-spacing: 0.5px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `FlocSearch_title__Q8CqG`
};
export default ___CSS_LOADER_EXPORT___;
